export const loginForm = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "auto",
  width: "100%",
  maxWidth: "400px",
};

export const emailInput = {
  width: "100%",
  padding: "0",
  backgroundColor: "transparent",
  "& .MuiInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiInput-underline:after": {
    borderBottom: "none",
  },
  "& input": {
    width: "100%",
    fontSize: "1.375rem",
  },
};

export const passwordInput = {
  width: "100%",
  padding: "0",
  backgroundColor: "transparent",
  "& .MuiInput-underline:before": {
    borderBottom: "none",
  },
  "& .MuiInput-underline:after": {
    borderBottom: "none",
  },
  "& input": {
    width: "100%",
    fontSize: "1.375rem",
  },
};

export const label = {
  fontSize: "0.875rem",
  marginBottom: "0.25rem",
  marginTop: "0.5rem",
  alignSelf: "flex-start",
};

export const submitButton = {
  width: "100%",
  marginTop: "2.5rem",
  fontVariant: "all-small-caps",
  fontWeight: 600,
  fontSize: "0.875rem",
};
